module.exports = __webpack_public_path__ + "static/media/China-night.3dadd1b1.svg";